import React, { Suspense, useRef } from 'react';
import { useParams, Link } from "react-router-dom";
import styled from 'styled-components/macro';

import { VRCanvas } from '@react-three/xr'
import { useFrame, extend, useThree, } from '@react-three/fiber'
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
// import { Environment } from '@react-three/drei'

import Model from './Model'

const Content = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

const Btn = styled.button`
  border-radius: 50px;
  margin-bottom: 80px;
  background-color: #EF5196;
`;

extend({ OrbitControls });
const Fall = () => "Error";

const NewSkin = () => {
  const par = useParams();
  const color = (par && par.color) || 'FFD700';
  const CameraControls = () => {
    const {
      camera,
      gl: { domElement },
    } = useThree();
    const controls = useRef();
    useFrame((state) => controls.current.update());
    return <orbitControls ref={controls} args={[camera, domElement]} />;
  };
  
  return (
    <Content>
      <VRCanvas sessionInit={{ requiredFeatures: ['hit-test'] }} style={{ height: '100%' }}>
        <Suspense fallback={<Fall />}>
          <Model size={3} position={[0.1, -2, -0.1]} />
          <CameraControls />
          {/* <RimLight brightness="1000" color="#ff0000" position={[1, 1, 1]} /> */}
          <ambientLight color={`#${color}`} />
          <pointLight position={[10, 10, 10]} color={`#${color}`} />
          {/* <RimLight brightness="1000" color="#ff0000" position={[-1, -1, 2]} /> */}
          {/* <RimLight brightness="1000" color="#ff0000" position={[-1, -1, 2]} /> */}
        </Suspense>
      </VRCanvas>
      <h1 style={{ margin: '8px 16px' }}>Congratulation! You found a new Percy!</h1>
      <h3 style={{ margin: '8px 16px' }}>You found a new Percy!</h3>
      <p style={{ margin: '8px 16px' }}>Return to the home page to use the new skin.</p>
      <Link to="/"><Btn>HOME</Btn></Link>
    </Content>
  )
};

export default NewSkin;
